import { useContext, useEffect, useRef, useState } from "react";
import { AppTokenContext } from "../contexts/AppTokenContext";

const WPS_PAYLENS_SCRIPT_URL = process.env.REACT_APP_PAYLENS_SCRIPT_URL;

function WpsPaylens() {
  const ref = useRef(null);
  const tokenObj = useContext(AppTokenContext);
  const accessToken = tokenObj?.accessToken || "";
  const [wcReady, setWcReady] = useState(!!customElements.get("ecom-ai-assistant"));

  useEffect(() => {
    // Validate environment variable
    if (!WPS_PAYLENS_SCRIPT_URL) {
      console.error("[WpsPaylens] REACT_APP_PAYLENS_SCRIPT_URL environment variable is not set");
      return;
    }

    if (!document.querySelector(`script[src="${WPS_PAYLENS_SCRIPT_URL}"]`)) {
      const script = document.createElement("script");
      script.src = WPS_PAYLENS_SCRIPT_URL;
      script.type = "module";

      script.onerror = () => {
        console.error(`[WpsPaylens] Failed to load script from ${WPS_PAYLENS_SCRIPT_URL}`);
      };

      document.head.appendChild(script);
    }

    if (!customElements.get("ecom-ai-assistant")) {
      const timeoutId = setTimeout(() => {
        console.error("[WpsPaylens] Custom element 'ecom-ai-assistant' failed to load within timeout (10s)");
      }, 10000);

      customElements.whenDefined("ecom-ai-assistant").then(() => {
        clearTimeout(timeoutId);
        setWcReady(true);
      });

      return () => clearTimeout(timeoutId);
    }
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el || !wcReady || !accessToken) return;
    el.accessToken = accessToken;
    el.agent = 'wps-paylens';
    el.title = 'WPS PayLens';
    el.subtitle = 'Ask me anything about WPS transactions';
  }, [accessToken, wcReady]);

  if (!accessToken || !wcReady) return null;

  return (
    <ecom-ai-assistant ref={ref}>
      <ecom-ai-example icon="💳" label="Recent high-value" text="Find last 3 transactions above $50 for card 4242424242" />
      <ecom-ai-example icon="🕐" label="Payment details" text="What details can you show for last payment from 4242424242" />
      <ecom-ai-example icon="🔍" label="Lookup by token" text="Look up transaction with token S4935413902424781" />
      <ecom-ai-example icon="📋" label="Search by ID" text="Search trans:345308" />
      <ecom-ai-example icon="⭐" label="Payment token info" text="What details can you show for payment token S5378321750950202?" />
    </ecom-ai-assistant>
  );
}

export default WpsPaylens;